import type {SketchPointObject} from '../SketchPointObject';

/**
 * 判断草图点是否允许作为实体选择对象。
 *
 * 设计说明：
 * 1. 正式草图点和控制点继续沿用既有选择语义；
 * 2. 原点投影、特征面边界角点和边中点属于草图会话参考，只能向点捕捉管理器提供坐标；
 * 3. 选择资格与可见性、可捕捉性相互独立，禁止通过隐藏对象或关闭射线拾取破坏捕捉链路。
 *
 * @param point 草图点对象。
 * @returns 允许进入实体选择链时返回 `true`。
 */
export function isSketchPointEntitySelectable(point: SketchPointObject): boolean {
    return !point.isDrawingSketchOrigin && !point.isSketchSessionReferencePoint;
}
